import { automationsConstants } from '@constants/automations';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { automationsService } from '@services';

function request() {
    return { type: automationsConstants.AUTOMATIONS_FETCH };
}

function success(data) {
    return { type: automationsConstants.AUTOMATIONS_SUCCESS, data };
}

function failure(message) {
    return { type: automationsConstants.AUTOMATIONS_ERROR, message };
}

const get = (page = 0, pageSize = DEFAULT_PAGE_SIZE) => {
    return dispatch => {
        dispatch(request());
        return automationsService.get(page, pageSize).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

export const automationsActions = { get };
